export default __webpack_public_path__ + "b32f34f0a408a1a023659e7ae4ddc7c5.png";